import { render } from "./DeleteFirm.vue?vue&type=template&id=90cb0a9c"
import script from "./DeleteFirm.vue?vue&type=script&lang=js"
export * from "./DeleteFirm.vue?vue&type=script&lang=js"

import exportComponent from "E:\\admin.contactweb.cz\\admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__